import { createActionGroup, props } from '@ngrx/store';
import { IServerSideGetRowsRequest } from 'ag-grid-community/dist/types/src/interfaces/iServerSideDatasource';
import { HttpErrorResponse } from '@angular/common/http';
import { IGroupedScoredConversation, ScoredConversationModel } from '../models/scored-conversations.model';

export const SCORED_CONVERSATIONS_API_ACTIONS = createActionGroup({
  source: 'Scorecard Conversations API',
  events: {
    get: props<{ request: Partial<IServerSideGetRowsRequest> }>(),
    success: props<{
      scorecardsConversations: ScoredConversationModel[] | IGroupedScoredConversation[];
      totalCount: number;
    }>(),
    error: props<{ error: HttpErrorResponse }>(),
  },
});

export const SCORED_CONVERSATIONS_ACTIONS = createActionGroup({
  source: 'Scorecard Conversations',
  events: {
    setActiveView: props<{ viewName: string | null }>(),
  },
});
